import React, { useState, useMemo, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';
import useGlobalPublishedPpsis from 'features/PpsiContainer/hooks/useGlobalPublishedPpsis';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import { toJS } from '../utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)',
    maxWidth: '800px', // Adjust this value to decrease the width
    margin: '0 auto' // Center the container horizontally
  },
  header: {
    backgroundColor: '#fafafa',
    height: 64,
    paddingTop: 16,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  headerText: {
    paddingLeft: 16,
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '1.6'
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 15,
    paddingLeft: 15,
    backgroundColor: '#fff',
    paddingBottom: 15,
    borderRadius: 4,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: theme.spacing(1)
  },
  gridItem: {
    textAlign: 'center'
  },
  card: {
    // border: '1px solid #ccc',
    borderRadius: 4,
    padding: theme.spacing(2),
    margin: '0 1rem 1rem 0',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#fff',
    boxShadow: '0 0 0.5rem 0 rgba(0, 0, 0, 0.1)'
  },
  cardImage: {
    width: '100%',
    height: 'auto'
  },
  link: {
    color: 'black',
    fontWeight: 'bold',
    textDecoration: 'none',
    '&:visited': {
      color: 'black'
    }
  }
}));

const GlobalPpsiGridView = () => {
  const classes = useStyles();
  const location = useLocation();
  const [name, setName] = useState('');
  const [isFetchingPpsis, globalDishesRaw] = useGlobalPublishedPpsis();
  const globalDishes = toJS(globalDishesRaw);

  const placeholderImage = 'https://fakeimg.pl/100x100/cccccc/909090';

  if (isFetchingPpsis) {
    return <ProgressFullscreen open />;
  }

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.header}>
          <span className={classes.headerText}>
            {`Global PPSIs (${globalDishes.length} dishes found)`}
          </span>
        </div>
        <div className={classes.paper}>
          <Grid container spacing={2}>
            {globalDishes.map((entry, index) => {
              const thumbnailUrl =
                entry.publishedPpsiEnrichmentData &&
                entry.publishedPpsiEnrichmentData.mainImage &&
                entry.publishedPpsiEnrichmentData.mainImage.thumbnailUrl;
              let presentationName = 'TEST';
              if (
                entry &&
                entry.publishedPpsiEnrichmentData &&
                entry.publishedPpsiEnrichmentData.info &&
                entry.publishedPpsiEnrichmentData.info['EN-IF']
              ) {
                presentationName =
                  entry.publishedPpsiEnrichmentData.info['EN-IF']
                    .presentationName || 'COULD NOT READ NAME';
              }

              return (
                <Grid item xs={3} key={index} className={classes.gridItem}>
                  <Link
                    to={{
                      pathname: `/ppsis/${entry.id}`,
                      state: { from: location }
                    }}
                    className={classes.cardLink}
                    style={{ textDecoration: 'none' }}
                  >
                    <div className={classes.card}>
                      {thumbnailUrl ? (
                        <img
                          src={thumbnailUrl}
                          alt={`Thumbnail ${index + 1}`}
                          className={classes.cardImage}
                        />
                      ) : (
                        <p>No image found</p>
                      )}

                      <div>
                        <p
                          style={{ fontWeight: 'bold', textDecoration: 'none' }}
                        >
                          {presentationName || 'TEST'}
                        </p>
                      </div>
                    </div>
                  </Link>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default GlobalPpsiGridView;
